import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import MultiSelect from "multiselect-react-dropdown";
import { UserProfileContext } from "../contexts/UserProfileStepsContext";
import Select from "react-select";
import {
  addProfileValidation,
  base_url,
  errorResponseMessage,
  httpHeaderConfig,
} from "../shared/const.prop";
import ErrorMessage from "../components/ErrorMessage";
import axios from "axios";
import { AppContext } from "../contexts/AppContext";

const AddProfileInfo = () => {
  const userContext = useContext(UserProfileContext);
  const appContext = useContext(AppContext);
  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm({
    defaultValues: {
      firstName: userContext?.userProfile?.firstName || "",
      lastName: userContext?.userProfile?.lastName || "",
      // dob: userContext?.userProfile?.dob || "",
      gender: userContext?.userProfile?.gender || "",
      contactNo: userContext?.userProfile?.contactNo || "",
      whatsappNo: userContext?.userProfile?.whatsappNo || "",
      language: userContext?.userProfile?.language || [],
      link: userContext?.userProfile?.link || "",
      country: "",
      state: userContext?.userProfile?.state || "",
      city: userContext?.userProfile?.city || "",
      phoneCode: userContext?.userProfile?.phoneCode || "",
      experiences: userContext?.userProfile?.experiences || "",
      timeZone: "",
    },
  });
  useEffect(() => {
    if (country.length && timeZoneList.length) {
      reset({
        firstName: userContext?.userProfile?.firstName || "",
        lastName: userContext?.userProfile?.lastName || "",
        gender: userContext?.userProfile?.gender || "",
        contactNo: userContext?.userProfile?.contactNo || "",
        whatsappNo: userContext?.userProfile?.whatsappNo || "",
        language: userContext?.userProfile?.language || [],
        link: userContext?.userProfile?.link || "",
        country: "101",
        state: userContext?.userProfile?.state || "",
        city: userContext?.userProfile?.city || "",
        phoneCode: userContext?.userProfile?.phoneCode || "",
        experiences: userContext?.userProfile?.experiences || "",
        timeZone: "66291756f5181c284d0dbbf0",
      });
    }
  }, [country, reset, timeZoneList, userContext]);

  const submitHandler = (data) => {
    userContext.updateUserInfo("updateUserInfo", data, "userProfile");
  };

  useEffect(() => {
    (() => {
      Promise.allSettled([
        axios.get(`${base_url}countries`, {
          headers: httpHeaderConfig,
        }),
        axios.get(`${base_url}languages`, {
          headers: httpHeaderConfig,
        }),
        axios.get(`${base_url}timezone`, { headers: httpHeaderConfig }),
      ])
        .then((response) => {
          const [countryResponse, languageResponse, timezoneResponse] =
            response;
          setCountry(
            countryResponse?.status === "fulfilled"
              ? countryResponse?.value?.data?.data
              : []
          );
          setLanguages(
            languageResponse?.status === "fulfilled"
              ? languageResponse?.value?.data?.data
              : []
          );
          setTimeZoneList(timezoneResponse?.value?.data?.data);
        })
        .catch((err) => {
          if (err.response?.status >= 500) {
            appContext.updateNotificationState({
              show: true,
              message: "Something went wrong, please try again later.",
              type: "error",
            });
            return;
          }
          appContext.updateNotificationState({
            type: "error",
            message: errorResponseMessage(err),
            show: true,
          });
        });
    })();
  }, []);

  //handle country & state set if user navigate back
  useEffect(() => {
    if (userContext.userProfile.country && userContext.currentPage === 1)
      fetchStates(userContext.userProfile.country);
  }, [userContext.currentPage]);

  async function fetchStates(countryId) {
    try {
      const stateData = await axios.get(
        `${base_url}states?country_id=${countryId}`,
        { headers: httpHeaderConfig }
      );
      if (stateData.status === 200) {
        setStates([...stateData.data.data]);
        if (userContext.userProfile.state) {
          setValue("country", userContext.userProfile.country);
          setValue("state", userContext.userProfile.state);
        }
      }
    } catch (err) {
      if (err.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
        return;
      }
      appContext.updateNotificationState({
        type: "error",
        message: errorResponseMessage(err),
        show: true,
      });
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(submitHandler)}>
        <div className="">
          <div className="row mt-5 mb-5">
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.2265 11.1287C11.2265 13.3261 8.21317 13.5801 5.94717 13.5801L5.78501 13.5799C4.34131 13.5764 0.666504 13.4853 0.666504 11.1154C0.666504 8.96291 3.55874 8.67524 5.80749 8.6644L6.10932 8.6642C7.55293 8.66771 11.2265 8.75886 11.2265 11.1287ZM5.94717 9.66406C3.1065 9.66406 1.6665 10.1521 1.6665 11.1154C1.6665 12.0874 3.1065 12.5801 5.94717 12.5801C8.78717 12.5801 10.2265 12.0921 10.2265 11.1287C10.2265 10.1567 8.78717 9.66406 5.94717 9.66406ZM5.94717 0.33313C7.89917 0.33313 9.4865 1.92113 9.4865 3.87313C9.4865 5.82513 7.89917 7.41246 5.94717 7.41246H5.92584C3.97784 7.40646 2.39984 5.8178 2.40648 3.87113C2.40648 1.92113 3.9945 0.33313 5.94717 0.33313ZM5.94717 1.28513C4.51984 1.28513 3.35849 2.4458 3.35849 3.87313C3.35384 5.2958 4.5065 6.4558 5.92784 6.46113L5.94717 6.93713V6.46113C7.37384 6.46113 8.5345 5.2998 8.5345 3.87313C8.5345 2.4458 7.37384 1.28513 5.94717 1.28513Z"
                      fill="#000842"
                    />
                  </svg>
                </span>
                <label className="has-float-label ">
                  <input
                    className="form-control form py-3"
                    type="text"
                    {...register("firstName", addProfileValidation.firstName)}
                  />
                  <span>
                    First Name <span className="text-danger">*</span>
                  </span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="firstName" />
            </div>
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="14"
                    viewBox="0 0 12 14"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.2265 11.1287C11.2265 13.3261 8.21317 13.5801 5.94717 13.5801L5.78501 13.5799C4.34131 13.5764 0.666504 13.4853 0.666504 11.1154C0.666504 8.96291 3.55874 8.67524 5.80749 8.6644L6.10932 8.6642C7.55293 8.66771 11.2265 8.75886 11.2265 11.1287ZM5.94717 9.66406C3.1065 9.66406 1.6665 10.1521 1.6665 11.1154C1.6665 12.0874 3.1065 12.5801 5.94717 12.5801C8.78717 12.5801 10.2265 12.0921 10.2265 11.1287C10.2265 10.1567 8.78717 9.66406 5.94717 9.66406ZM5.94717 0.33313C7.89917 0.33313 9.4865 1.92113 9.4865 3.87313C9.4865 5.82513 7.89917 7.41246 5.94717 7.41246H5.92584C3.97784 7.40646 2.39984 5.8178 2.40648 3.87113C2.40648 1.92113 3.9945 0.33313 5.94717 0.33313ZM5.94717 1.28513C4.51984 1.28513 3.35849 2.4458 3.35849 3.87313C3.35384 5.2958 4.5065 6.4558 5.92784 6.46113L5.94717 6.93713V6.46113C7.37384 6.46113 8.5345 5.2998 8.5345 3.87313C8.5345 2.4458 7.37384 1.28513 5.94717 1.28513Z"
                      fill="#000842"
                    />
                  </svg>
                </span>
                <label className="has-float-label">
                  <input
                    className="form-control  form py-3"
                    type="text"
                    {...register("lastName", addProfileValidation.lastName)}
                  />
                  <span>
                    Last Name <span className="text-danger">*</span>
                  </span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="lastName" />
            </div>
            {/* <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.5292 0.666672C10.8052 0.666672 11.0292 0.890672 11.0292 1.16667L11.0295 1.73188C12.0029 1.79862 12.8113 2.13204 13.3835 2.70541C14.0082 3.33274 14.3368 4.23474 14.3335 5.31674V11.3987C14.3335 13.6201 12.9228 15.0001 10.6528 15.0001H5.01416C2.74416 15.0001 1.3335 13.6007 1.3335 11.3481V5.31541C1.3335 3.2202 2.59153 1.8753 4.64329 1.73211L4.6437 1.16667C4.6437 0.890672 4.8677 0.666672 5.1437 0.666672C5.4197 0.666672 5.6437 0.890672 5.6437 1.16667L5.6435 1.71934H10.0288L10.0292 1.16667C10.0292 0.890672 10.2532 0.666672 10.5292 0.666672ZM13.3335 6.60267H2.3335V11.3481C2.3335 13.0587 3.2855 14.0001 5.01416 14.0001H10.6528C12.3815 14.0001 13.3335 13.0761 13.3335 11.3987L13.3335 6.60267ZM10.801 10.7975C11.077 10.7975 11.301 11.0215 11.301 11.2975C11.301 11.5735 11.077 11.7975 10.801 11.7975C10.525 11.7975 10.2983 11.5735 10.2983 11.2975C10.2983 11.0215 10.519 10.7975 10.795 10.7975H10.801ZM7.84263 10.7975C8.11863 10.7975 8.34263 11.0215 8.34263 11.2975C8.34263 11.5735 8.11863 11.7975 7.84263 11.7975C7.56663 11.7975 7.33996 11.5735 7.33996 11.2975C7.33996 11.0215 7.56063 10.7975 7.83663 10.7975H7.84263ZM4.8781 10.7975C5.1541 10.7975 5.3781 11.0215 5.3781 11.2975C5.3781 11.5735 5.1541 11.7975 4.8781 11.7975C4.6021 11.7975 4.37476 11.5735 4.37476 11.2975C4.37476 11.0215 4.5961 10.7975 4.8721 10.7975H4.8781ZM10.801 8.20641C11.077 8.20641 11.301 8.43041 11.301 8.70641C11.301 8.98241 11.077 9.20641 10.801 9.20641C10.525 9.20641 10.2983 8.98241 10.2983 8.70641C10.2983 8.43041 10.519 8.20641 10.795 8.20641H10.801ZM7.84263 8.20641C8.11863 8.20641 8.34263 8.43041 8.34263 8.70641C8.34263 8.98241 8.11863 9.20641 7.84263 9.20641C7.56663 9.20641 7.33996 8.98241 7.33996 8.70641C7.33996 8.43041 7.56063 8.20641 7.83663 8.20641H7.84263ZM4.8781 8.20641C5.1541 8.20641 5.3781 8.43041 5.3781 8.70641C5.3781 8.98241 5.1541 9.20641 4.8781 9.20641C4.6021 9.20641 4.37476 8.98241 4.37476 8.70641C4.37476 8.43041 4.5961 8.20641 4.8721 8.20641H4.8781ZM10.0288 2.71934H5.6435L5.6437 3.36067C5.6437 3.63667 5.4197 3.86067 5.1437 3.86067C4.8677 3.86067 4.6437 3.63667 4.6437 3.36067L4.64334 2.73447C3.14985 2.85993 2.3335 3.76524 2.3335 5.31541V5.60267H13.3335L13.3335 5.31541C13.3362 4.49207 13.1148 3.85207 12.6755 3.41207C12.2898 3.02528 11.7261 2.79427 11.0297 2.73479L11.0292 3.36067C11.0292 3.63667 10.8052 3.86067 10.5292 3.86067C10.2532 3.86067 10.0292 3.63667 10.0292 3.36067L10.0288 2.71934Z"
                      fill="#000842"
                    />
                  </svg>
                </span>
                <label className="has-float-label">
                  <input
                    className="form-control  form py-3"
                    type="date"
                    {...register("dob", addProfileValidation.dob)}
                  />
                  <span>
                    DOB <span className="text-danger">*</span>
                  </span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="dob" />
            </div> */}
          </div>
          <div className="row mb-5">
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.49983 2C9.36722 2 9.24004 1.94732 9.14628 1.85355C9.05251 1.75979 8.99983 1.63261 8.99983 1.5C8.99983 1.36739 9.05251 1.24021 9.14628 1.14645C9.24004 1.05268 9.36722 1 9.49983 1H14.4998C14.6324 1 14.7596 1.05268 14.8534 1.14645C14.9472 1.24021 14.9998 1.36739 14.9998 1.5V6.5C14.9998 6.63261 14.9472 6.75979 14.8534 6.85355C14.7596 6.94732 14.6324 7 14.4998 7C14.3672 7 14.24 6.94732 14.1463 6.85355C14.0525 6.75979 13.9998 6.63261 13.9998 6.5V2.707L9.87083 6.836C10.6826 7.82919 11.0817 9.0964 10.9854 10.3755C10.8892 11.6547 10.305 12.8479 9.35364 13.7084C8.40233 14.5689 7.15669 15.0309 5.87434 14.9987C4.59198 14.9666 3.37102 14.4429 2.46398 13.5359C1.55694 12.6288 1.03319 11.4078 1.00108 10.1255C0.968966 8.84314 1.43093 7.5975 2.29144 6.64619C3.15194 5.69488 4.34516 5.11068 5.6243 5.01442C6.90343 4.91815 8.17064 5.31719 9.16383 6.129L13.2928 2H9.49983ZM5.99983 6C4.93896 6 3.92155 6.42143 3.1714 7.17157C2.42126 7.92172 1.99983 8.93913 1.99983 10C1.99983 11.0609 2.42126 12.0783 3.1714 12.8284C3.92155 13.5786 4.93896 14 5.99983 14C7.0607 14 8.07811 13.5786 8.82826 12.8284C9.5784 12.0783 9.99983 11.0609 9.99983 10C9.99983 8.93913 9.5784 7.92172 8.82826 7.17157C8.07811 6.42143 7.0607 6 5.99983 6Z"
                      fill="#000842"
                    />
                  </svg>
                </span>
                <label className="form-group has-float-label">
                  <select
                    className="form-control  select select-custom"
                    {...register("gender", addProfileValidation.gender)}
                  >
                    <option value="M">Male</option>
                    <option value="F">Female</option>
                    <option value="O">Others</option>
                  </select>
                  <span>
                    Gender <span className="text-danger">*</span>
                  </span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="gender" />
            </div>
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M4.43827 1.3336C5.18294 1.3436 5.71361 1.9016 6.38494 2.6076C6.55094 2.7816 6.73027 2.9716 6.93094 3.1716C7.90361 4.14493 7.62694 4.93893 7.40361 5.57626C7.16094 6.2716 6.95094 6.8716 8.20827 8.12893C9.46561 9.38626 10.0649 9.17626 10.7596 8.9316C11.3976 8.70893 12.1896 8.43026 13.1643 9.4036C13.3623 9.6016 13.5489 9.77893 13.7223 9.9436C14.4309 10.6183 14.9909 11.1509 15.0004 11.8976C15.0076 12.5336 14.6209 13.1829 13.6663 14.1376L13.2436 13.8509L13.6016 14.1996C13.3903 14.4163 12.8283 14.9936 11.7276 15.0003H11.7076C10.0463 15.0003 7.88027 13.6776 5.26961 11.0676C2.64827 8.44693 1.32361 6.27426 1.33355 4.6096C1.33961 3.5096 1.91627 2.94626 2.13294 2.73493L2.15143 2.71473L2.19627 2.6696C3.15294 1.71293 3.81027 1.3196 4.43827 1.3336ZM4.42561 2.3336H4.42027C4.1209 2.3336 3.66625 2.6336 3.03216 3.24953L2.90483 3.37457L2.90627 3.37426C2.90627 3.37426 2.89539 3.38674 2.87685 3.40566L2.83227 3.45026C2.67094 3.60693 2.33694 3.93293 2.33357 4.61493C2.32827 5.56893 2.95561 7.34026 5.97627 10.3603C8.98227 13.3656 10.7509 14.0003 11.7076 14.0003H11.7216C12.4036 13.9963 12.7289 13.6623 12.8856 13.5016C12.9329 13.4529 12.9716 13.4163 12.9989 13.3943C13.6636 12.7256 14.0036 12.2289 14.0003 11.9096C13.9963 11.5843 13.5916 11.2003 13.0323 10.6676C12.8543 10.4989 12.6609 10.3143 12.4569 10.1103C11.9276 9.58293 11.6669 9.67293 11.0903 9.8756C10.2936 10.1549 9.20227 10.5376 7.50161 8.8356C5.80027 7.13493 6.18161 6.0436 6.45961 5.24626C6.66094 4.67026 6.75294 4.40826 6.22427 3.87893C6.01761 3.67226 5.83161 3.47626 5.66027 3.29626C5.13094 2.74026 4.74894 2.33826 4.42561 2.3336ZM10.1643 3.70526C11.5517 3.9746 12.623 5.04526 12.893 6.43326C12.9457 6.70526 12.769 6.96726 12.4983 7.01993C12.4657 7.02593 12.4337 7.02926 12.4017 7.02926C12.167 7.02926 11.9583 6.86393 11.9117 6.62526C11.7197 5.6386 10.959 4.87793 9.97367 4.6866C9.70234 4.63393 9.52567 4.37193 9.57834 4.1006C9.63101 3.82926 9.89767 3.65193 10.1643 3.70526ZM10.1244 1.3374C12.8431 1.6394 14.9544 3.74806 15.2591 6.46606C15.2897 6.74073 15.0924 6.98806 14.8184 7.01873C14.7997 7.02073 14.7804 7.02206 14.7617 7.02206C14.5104 7.02206 14.2944 6.8334 14.2657 6.57806C14.0131 4.3274 12.2651 2.58073 10.0137 2.33073C9.73974 2.30006 9.54174 2.0534 9.57241 1.77873C9.60241 1.50473 9.84707 1.30273 10.1244 1.3374Z"
                      fill="#000842"
                    />
                  </svg>
                </span>
                <label className="has-float-label">
                  <input
                    maxLength={15}
                    className="form-control form py-3"
                    type="number"
                    {...register("contactNo", addProfileValidation.contactNo)}
                  />
                  <span>Contact No</span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="contactNo" />
            </div>
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.252 3.752C11.6983 3.1949 11.0396 2.75319 10.314 2.45246C9.58847 2.15172 8.81043 1.99793 8.025 2C4.7325 2 2.05 4.68 2.05 7.9725C2.0475 9.02088 2.32248 10.0513 2.847 10.959L2 14.0545L5.168 13.2225C6.04399 13.6997 7.02546 13.9501 8.023 13.951H8.0255C11.3185 13.951 13.998 11.2715 14 7.9765C14 6.381 13.379 4.881 12.252 3.7515V3.752ZM8.025 12.9415H8.023C7.13378 12.9415 6.26088 12.7027 5.4955 12.25L5.314 12.1425L3.433 12.635L3.935 10.8025L3.818 10.615C3.3203 9.82357 3.05681 8.90741 3.058 7.9725C3.058 5.2365 5.2865 3.01 8.027 3.01C8.67921 3.00837 9.32526 3.13613 9.92776 3.38588C10.5303 3.63563 11.0772 4.00242 11.537 4.465C11.999 4.92536 12.3653 5.4727 12.6146 6.07542C12.8639 6.67813 12.9913 7.32426 12.9895 7.9765C12.9895 10.715 10.7615 12.9415 8.025 12.9415ZM10.7475 9.2225C10.599 9.1485 9.8645 8.7875 9.728 8.7385C9.5915 8.6875 9.4915 8.664 9.392 8.8125C9.292 8.9625 9.007 9.299 8.9195 9.3985C8.8335 9.496 8.7455 9.51 8.597 9.4355C8.447 9.3615 7.9665 9.203 7.396 8.6935C6.9525 8.2985 6.652 7.8085 6.566 7.66C6.478 7.51 6.556 7.43 6.6305 7.355C6.6985 7.289 6.7805 7.1815 6.855 7.0935C6.929 7.008 6.955 6.9455 7.005 6.8455C7.054 6.746 7.029 6.658 6.9915 6.584C6.9545 6.51 6.656 5.7735 6.531 5.4745C6.4095 5.1835 6.2865 5.2245 6.195 5.219C6.109 5.215 6.0095 5.215 5.91 5.215C5.81 5.215 5.648 5.252 5.511 5.4025C5.3745 5.551 4.9895 5.9125 4.9895 6.6465C4.9895 7.381 5.5245 8.0915 5.5995 8.1915C5.6735 8.289 6.652 9.7965 8.1495 10.4435C8.42699 10.5635 8.71073 10.6685 8.9995 10.758C9.357 10.871 9.683 10.8555 9.941 10.818C10.228 10.7755 10.8235 10.457 10.9485 10.1075C11.072 9.76 11.072 9.461 11.0345 9.3985C10.9975 9.336 10.898 9.2985 10.7475 9.2225Z"
                      fill="#000842"
                    />
                  </svg>
                </span>
                <label className="has-float-label">
                  <input
                    // maxLength={15}
                    className="form-control  form py-3"
                    type="number"
                    {...register("whatsappNo", addProfileValidation.whatsappNo)}
                  />
                  <span>Whatsapp No</span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="whatsappNo" />
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M3.5012 6.65L11.2745 2.94867C12.4079 2.40867 13.5905 3.592 13.0512 4.726L9.34987 12.4987C8.84387 13.5607 7.31053 13.4953 6.8972 12.3933L6.2132 10.5673C6.14637 10.3892 6.04218 10.2274 5.90765 10.0929C5.77311 9.95835 5.61134 9.85417 5.4332 9.78733L3.60653 9.10267C2.5052 8.68933 2.4392 7.156 3.5012 6.65Z"
                      stroke="#000842"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <label className="form-group has-float-label">
                  <select
                    className="form-control select select-custom"
                    {...register("country", {
                      ...addProfileValidation.country,
                      onChange: (e) => fetchStates(e.target.value),
                    })}
                    disabled={true}
                  >
                    {!country.length && <option>No option available</option>}
                    {country.length && <option value="">Select option</option>}
                    {country.map((countryItem) => (
                      <option key={countryItem.id} value={countryItem.id}>
                        {countryItem.name}
                      </option>
                    ))}
                  </select>
                  <span>Country</span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="country" />
            </div>
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_78_548)">
                      <path
                        d="M6.69705 9.33333C5.69305 8.32533 5.78371 6.6 6.89905 5.48067L10.131 2.23667C11.2464 1.11667 12.9644 1.026 13.969 2.03333C14.973 3.04133 14.8824 4.76667 13.767 5.88667L12.151 7.50867"
                        stroke="#000842"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M9.30254 6.66667C10.3065 7.67467 10.2159 9.4 9.10054 10.5193L7.48454 12.1413L5.86854 13.7633C4.75321 14.8833 3.03521 14.974 2.03054 13.9667C1.02654 12.9587 1.11721 11.2333 2.23254 10.1133L3.84854 8.49133"
                        stroke="#000842"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_78_548">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <label className="has-float-label">
                  <select
                    className="form-control select select-custom"
                    {...register("state", addProfileValidation.state)}
                  >
                    {!states.length && <option>No option available</option>}
                    {states.length && <option value="">Select option</option>}
                    {states.map((stateItem) => (
                      <option key={stateItem.id} value={stateItem.id}>
                        {stateItem.name}
                      </option>
                    ))}
                  </select>
                  <span>State</span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="state" />
            </div>
            <div className="col-md-4">
              <div className="form-group input-group">
                <span className="input-group-addon addon-icon py-1">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_78_531)">
                      <path
                        d="M13.3331 1.33333H6.22201V3.55556H7.11089V2.22222H13.3331C13.5998 2.22222 13.7776 2.4 13.7776 2.66667V7.55556C13.7776 7.82222 13.5998 8 13.3331 8H7.55534V11.1111H5.19978L3.55534 12.4V11.1111H2.22201C1.95534 11.1111 1.77756 10.9333 1.77756 10.6667V5.77778C1.77756 5.51111 1.95534 5.33333 2.22201 5.33333H7.99978V4.44445H2.22201C1.46645 4.44445 0.888672 5.02222 0.888672 5.77778V10.6667C0.888672 11.4222 1.46645 12 2.22201 12H2.66645V14.2667L5.46645 12H8.44423V8.88889H13.3331C14.0887 8.88889 14.6664 8.31111 14.6664 7.55556V2.66667C14.6664 1.91111 14.0887 1.33333 13.3331 1.33333Z"
                        fill="#000842"
                      />
                      <path
                        d="M2.75537 10.1778H3.82204L4.0887 9.46667H5.46648L5.73315 10.1778H6.79982L5.2887 6.22222H4.22204L2.75537 10.1778ZM4.75537 7.33333L5.19982 8.71111H4.31093L4.75537 7.33333Z"
                        fill="#000842"
                      />
                      <path
                        d="M8.88867 7.55555C9.37756 7.55555 10.0442 7.42222 10.6664 7.11111C11.2887 7.42222 11.9998 7.55555 12.4442 7.55555V6.66667C12.4442 6.66667 11.9998 6.66667 11.5109 6.48889C12.0442 5.95556 12.4442 5.15556 12.4442 4V3.55555H11.1109V2.66667H10.222V3.55555H8.88867V4.44444H11.5109C11.422 5.24444 11.0664 5.73333 10.6664 6.04444C10.3998 5.82222 10.1331 5.51111 9.95534 5.11111H9.022C9.19978 5.68889 9.46645 6.13333 9.82201 6.48889C9.37756 6.66667 8.97756 6.66667 8.88867 6.66667V7.55555Z"
                        fill="#000842"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_78_531">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <label className="form-group has-float-label">
                  <input
                    type="text"
                    className="form-control select select-custom py-3"
                    {...register("city", addProfileValidation.city)}
                  />
                  <span>City</span>
                </label>
              </div>
              <ErrorMessage errors={errors} errorKey="city" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group input-group">
              <span className="input-group-addon addon-icon py-1">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_78_531)">
                    <path
                      d="M13.3331 1.33333H6.22201V3.55556H7.11089V2.22222H13.3331C13.5998 2.22222 13.7776 2.4 13.7776 2.66667V7.55556C13.7776 7.82222 13.5998 8 13.3331 8H7.55534V11.1111H5.19978L3.55534 12.4V11.1111H2.22201C1.95534 11.1111 1.77756 10.9333 1.77756 10.6667V5.77778C1.77756 5.51111 1.95534 5.33333 2.22201 5.33333H7.99978V4.44445H2.22201C1.46645 4.44445 0.888672 5.02222 0.888672 5.77778V10.6667C0.888672 11.4222 1.46645 12 2.22201 12H2.66645V14.2667L5.46645 12H8.44423V8.88889H13.3331C14.0887 8.88889 14.6664 8.31111 14.6664 7.55556V2.66667C14.6664 1.91111 14.0887 1.33333 13.3331 1.33333Z"
                      fill="#000842"
                    />
                    <path
                      d="M2.75537 10.1778H3.82204L4.0887 9.46667H5.46648L5.73315 10.1778H6.79982L5.2887 6.22222H4.22204L2.75537 10.1778ZM4.75537 7.33333L5.19982 8.71111H4.31093L4.75537 7.33333Z"
                      fill="#000842"
                    />
                    <path
                      d="M8.88867 7.55555C9.37756 7.55555 10.0442 7.42222 10.6664 7.11111C11.2887 7.42222 11.9998 7.55555 12.4442 7.55555V6.66667C12.4442 6.66667 11.9998 6.66667 11.5109 6.48889C12.0442 5.95556 12.4442 5.15556 12.4442 4V3.55555H11.1109V2.66667H10.222V3.55555H8.88867V4.44444H11.5109C11.422 5.24444 11.0664 5.73333 10.6664 6.04444C10.3998 5.82222 10.1331 5.51111 9.95534 5.11111H9.022C9.19978 5.68889 9.46645 6.13333 9.82201 6.48889C9.37756 6.66667 8.97756 6.66667 8.88867 6.66667V7.55555Z"
                      fill="#000842"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_78_531">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <label className="form-group has-float-label">
                <Controller
                  control={control}
                  name="language"
                  render={({ field: { value, onChange } }) => (
                    <MultiSelect
                      options={languages}
                      hidePlaceholder={true}
                      closeOnSelect={false}
                      onSelect={onChange}
                      onRemove={onChange}
                      selectedValues={value}
                      displayValue="name"
                      className="multi-select-wrapper"
                    />
                  )}
                />
                <span>Language</span>
              </label>
            </div>
            {/* {errors.language && (
              <p className="field-error">Language is required</p>
            )} */}
          </div>
          <div className="col-md-4">
            <div className="form-group input-group">
              <span className="input-group-addon addon-icon py-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_78_548)">
                    <path
                      d="M6.69705 9.33333C5.69305 8.32533 5.78371 6.6 6.89905 5.48067L10.131 2.23667C11.2464 1.11667 12.9644 1.026 13.969 2.03333C14.973 3.04133 14.8824 4.76667 13.767 5.88667L12.151 7.50867"
                      stroke="#000842"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M9.30254 6.66667C10.3065 7.67467 10.2159 9.4 9.10054 10.5193L7.48454 12.1413L5.86854 13.7633C4.75321 14.8833 3.03521 14.974 2.03054 13.9667C1.02654 12.9587 1.11721 11.2333 2.23254 10.1133L3.84854 8.49133"
                      stroke="#000842"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_78_548">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <label className="has-float-label">
                <input
                  className="form-control form py-4"
                  type="text"
                  {...register("link", addProfileValidation.link)}
                />
                <span>Link</span>
              </label>
            </div>
            <ErrorMessage errors={errors} errorKey="link" />
          </div>
          <div className="col-md-4">
            <div className="form-group input-group">
              <span className="input-group-addon addon-icon py-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clipPath="url(#clip0_78_548)">
                    <path
                      d="M6.69705 9.33333C5.69305 8.32533 5.78371 6.6 6.89905 5.48067L10.131 2.23667C11.2464 1.11667 12.9644 1.026 13.969 2.03333C14.973 3.04133 14.8824 4.76667 13.767 5.88667L12.151 7.50867"
                      stroke="#000842"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M9.30254 6.66667C10.3065 7.67467 10.2159 9.4 9.10054 10.5193L7.48454 12.1413L5.86854 13.7633C4.75321 14.8833 3.03521 14.974 2.03054 13.9667C1.02654 12.9587 1.11721 11.2333 2.23254 10.1133L3.84854 8.49133"
                      stroke="#000842"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_78_548">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <label className="has-float-label">
                <input
                  className="form-control form py-4"
                  type="text"
                  {...register("experiences", addProfileValidation.experiences)}
                />
                <span>
                  Headline<span className="text-danger">*</span>
                </span>
              </label>
            </div>
            {/* <ErrorMessage errors={errors} errorKey="experiences" /> */}
            {errors.experiences && (
              <p className="field-error">Headline required</p>
            )}
          </div>
        </div>

        <div className="row mt-5 mb-5">
          <div className="col-md-4">
            <div className="form-group input-group">
              <span className="input-group-addon addon-icon py-1">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5 18.54L11.131 17.829C11.847 17.009 12.491 16.231 13.064 15.491L13.537 14.867C15.512 12.206 16.5 10.094 16.5 8.533C16.5 5.201 13.814 2.5 10.5 2.5C7.186 2.5 4.5 5.201 4.5 8.533C4.5 10.094 5.488 12.206 7.463 14.867L7.936 15.491C8.75344 16.5384 9.60867 17.5547 10.5 18.54Z"
                    stroke="#666666"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.5 11C11.8807 11 13 9.88071 13 8.5C13 7.11929 11.8807 6 10.5 6C9.11929 6 8 7.11929 8 8.5C8 9.88071 9.11929 11 10.5 11Z"
                    stroke="#666666"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <label className="form-group register has-float-label">
                <Controller
                  name="timeZone"
                  control={control}
                  defaultValue={
                    userContext?.userProfile?.timezone ||
                    "66291756f5181c284d0dbbf0"
                  }
                  rules={addProfileValidation.timeZone}
                  render={({ field }) => {
                    const selectedValue = timeZoneList.find(
                      (option) => option._id?.$oid === field.value
                    );

                    return (
                      <Select
                        {...field}
                        options={timeZoneList.map(({ _id, text }) => ({
                          value: _id?.$oid,
                          label: text || "",
                        }))}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 1111,
                          }),
                        }}
                        value={
                          selectedValue
                            ? {
                                value: selectedValue._id.$oid,
                                label: selectedValue.text,
                              }
                            : {
                                value: "66291756f5181c284d0dbbf0",
                                label: "Kolkata",
                              }
                        }
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption?.value);
                        }}
                        isDisabled={!!userContext?.userProfile?.timeZone}
                      />
                    );
                  }}
                />

                <span>
                  TimeZone <span className="text-danger">*</span>
                </span>
              </label>
            </div>
            <ErrorMessage errors={errors} errorKey="timeZone" />
          </div>
        </div>

        <div className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <div className="justify-content-center">
              <button
                type="submit"
                className="btn btn-primary btn-block sign-btn  mt-5 mb-5"
              >
                Continue
              </button>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div>
      </form>
    </>
  );
};

export default AddProfileInfo;
